import React from "react";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
import {
    getIngresosCellStyle,
    getReajusteCellStyle,
} from "../../utils/AlmacenesTable";
import { EstadoAlmacenInventario } from "../../../../components/Almacenes/EstadoAlmacenInventario";
import { useAlmacenRow } from "../../hooks/useAlmacenRow";
import { ActionsCell } from "./ActionsCell";
import { ESTADOS_INV_ALMACEN } from "../../../../../../../../utility/constants";

export const AlmacenRow = ({
    item,
    estaCerrado,
    setAlmacenInvReajuste,
    ActualizarEstadoAlmacen,
    verIngresosAlmacen,
}) => {
    const {
        hoveredId,
        setHoveredId,
        invFinalLab,
        invFinalLiq,
        enviadoProdLab,
        enviadoProdLiq,
    } = useAlmacenRow({
        item,
    });

    const [hoveredIngresos, setHoveredIngresos] = React.useState(false);

    // El almacén de reproceso arranca en cero y su inventario inicial es lo que
    // quedó del periodo anterior, así que no se reajusta a mano
    const propsReajusteInicial = item.es_reproceso
        ? {}
        : {
              style: getReajusteCellStyle(item, estaCerrado, hoveredId),
              onMouseEnter: () => setHoveredId(item.almacen_id),
              onMouseLeave: () => setHoveredId(null),
              onClick: () => !estaCerrado && setAlmacenInvReajuste(item),
              title: "Reajustar inventario inicial",
          };

    return (
        <tr key={item.inventario_almacen_id}>
            <td className="text-center text-nowrap">
                {item.nombre_almacen}
            </td>
            <td className="text-center text-nowrap">{item.materia_prima}</td>

            {/* INVENTARIO INICIAL */}
            <td className="text-center text-nowrap" {...propsReajusteInicial}>
                <RenderNumber
                    value={item.anterior.kg_secos_lab}
                    decimalScale={3}
                />
            </td>
            <td className="text-center text-nowrap" {...propsReajusteInicial}>
                <RenderNumber
                    value={item.anterior.kg_secos_liq}
                    decimalScale={3}
                />
            </td>

            {/* INGRESOS */}
            <td
                className="text-center text-nowrap"
                style={getIngresosCellStyle(item, hoveredIngresos)}
                onMouseEnter={() => setHoveredIngresos(item.almacen_id)}
                onMouseLeave={() => setHoveredIngresos(null)}
                onClick={() => verIngresosAlmacen(item.inventario_almacen_id)}
                title={
                    item.ingresos_periodo.drc_faltante
                        ? "DRC Faltante"
                        : "Ver ingresos de almacén"
                }
            >
                <RenderNumber
                    value={item.ingresos_periodo.kg_secos_lab}
                    decimalScale={3}
                />
            </td>
            <td
                className="text-center text-nowrap"
                style={getIngresosCellStyle(item, hoveredIngresos)}
                onMouseEnter={() => setHoveredIngresos(item.almacen_id)}
                onMouseLeave={() => setHoveredIngresos(null)}
                onClick={() => verIngresosAlmacen(item.inventario_almacen_id)}
                title={
                    item.ingresos_periodo.drc_faltante
                        ? "DRC Faltante"
                        : "Ver ingresos de almacén"
                }
            >
                <RenderNumber
                    value={item.ingresos_periodo.kg_secos_liq}
                    decimalScale={3}
                />
            </td>

            {/* SOBRANTE IDs */}
            <td className="text-center text-nowrap">
                {item.actual.kg_secos_movimientos_lab ? (
                    <RenderNumber
                        value={item.actual.kg_secos_movimientos_lab}
                        decimalScale={3}
                    />
                ) : (
                    "—"
                )}
            </td>
            <td className="text-center text-nowrap">
                {item.actual.kg_secos_movimientos_liq ? (
                    <RenderNumber
                        value={item.actual.kg_secos_movimientos_liq}
                        decimalScale={3}
                    />
                ) : (
                    "—"
                )}
            </td>

            {/* PESO SOBRANTE EN ALMACENES */}
            <td className="text-center text-nowrap">
                {item.actual.kg_secos_analisis_lab ? (
                    <RenderNumber
                        value={item.actual.kg_secos_analisis_lab}
                        decimalScale={3}
                    />
                ) : (
                    "—"
                )}
            </td>
            <td className="text-center text-nowrap">
                {item.actual.kg_secos_analisis_liq ? (
                    <RenderNumber
                        value={item.actual.kg_secos_analisis_liq}
                        decimalScale={3}
                    />
                ) : (
                    "—"
                )}
            </td>

            {/* ENVIADO A PRODUCCIÓN */}
            <td className="text-center text-nowrap">
                <NullableValue value={enviadoProdLab}>
                    <RenderNumber value={enviadoProdLab} decimalScale={3} />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap">
                <NullableValue value={enviadoProdLiq}>
                    <RenderNumber value={enviadoProdLiq} decimalScale={3} />
                </NullableValue>
            </td>

            {/* INVENTARIO FINAL */}
            <td className="text-center text-nowrap">
                {item.estado !== ESTADOS_INV_ALMACEN.PENDIENTE &&
                item.estado !== ESTADOS_INV_ALMACEN.PENDIENTE_ANALISIS ? (
                    <RenderNumber value={invFinalLab} decimalScale={3} />
                ) : (
                    "—"
                )}
            </td>
            <td className="text-center text-nowrap">
                {item.estado !== ESTADOS_INV_ALMACEN.PENDIENTE &&
                item.estado !== ESTADOS_INV_ALMACEN.PENDIENTE_ANALISIS ? (
                    <RenderNumber value={invFinalLiq} decimalScale={3} />
                ) : (
                    "—"
                )}
            </td>

            <td>{EstadoAlmacenInventario(item.estado)}</td>

            <td className="text-center text-nowrap">
                <ActionsCell
                    item={item}
                    estaCerrado={estaCerrado}
                    ActualizarEstadoAlmacen={ActualizarEstadoAlmacen}
                />
            </td>
        </tr>
    );
};
